<template>
  <v-card id="Reciepts" class="mb-2">
    <v-card-title>
      <v-btn elevation="1" class="mr-3" fab small @click="TOGGLE_CLOSED_BLOCK('reciepts')" color="white">
        <v-icon>
          mdi-dots-vertical
        </v-icon>
      </v-btn>
      <h2>Выписанные рецепты</h2>
      <v-spacer></v-spacer>

      <modal depressed icon="add" title="Назначить лекарство" name="Рецепт" component="add-medicine-reciept"></modal>
    </v-card-title>
    <v-data-table v-if="isShow" item-key="uuid" :headers="headers" :items="items">
      <template v-slot:item.created_at="{ item }">
        {{ $date(item.created_at).format("DD.MM.YY") }}
      </template>
      <template v-slot:item.period_amount="{ item }">
        {{ item.intake_amount }}
        {{ item.measure_unit.name }}
        {{ item.dosage_amount }} раз в
        {{ item.duration }}
        {{ item.duration_unit.name }}
        с {{ $date(item.start_at).format("DD.MM.YY") }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon @click.stop="deleteItem(item)">mdi-delete</v-icon>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import Modal from "@/components/Modal";
import { mapState, mapMutations } from "vuex";
export default {
  name: "Reciepts",
  components: { Modal },
  data() {
    return {
      headers: [
        {
          text: "Выписан",

          sortable: true,
          value: "created_at",
        },
        {
          text: "Лекарство",

          sortable: true,
          value: "mnn.name",
        },
        {
          text: "Принимать",

          sortable: true,
          value: "period_amount",
        },
        {
          text: "Диагноз",

          sortable: true,
          value: "disease.name",
        },
        { text: "", value: "actions", align: "right", sortable: false },
      ],
    };
  },
  computed: {
    ...mapState("ikp", ["closedBlocks"]),
    ...mapState("reciepts", ["items"]),
    isShow() {
      return !this.closedBlocks.includes("reciepts");
    },
  },
  methods: {
    ...mapMutations("ikp", ["TOGGLE_CLOSED_BLOCK"]),
    ...mapMutations("reciepts", ["SET_ITEMS"]),
    async deleteItem(item) {
      const result = await this.$dialog.confirm({
        title: "Удаление рецепта",
        text: `Вы подтверждаете удаление рецепта?`,
      });

      if (result) {
        this.loading = true;
        await this.$store.dispatch("reciepts/removeItem", item);

        // if (this.items.length === 0) {
        //   await this.load();
        // }

        this.loading = false;
      }
    },
  },
  async created() {
    const { data } = await this.$http.get(`v1/customers/${this.$store.state.customer.id}/drugs`);
    this.SET_ITEMS(data.data);
  },
};
</script>

<style></style>
